import { cn } from '@/shared/utils/cn';

export interface SkeletonProps {
  /** Optional class name for layout (width, height, rounded). */
  className?: string;
  /** Inline style for dimensions when className is not enough. */
  style?: React.CSSProperties;
}

/**
 * Generic skeleton placeholder – pulse animation, gray background.
 * Use for loading states; pair with layout classes (e.g. w-full h-4 rounded).
 */
export function Skeleton({ className, style }: SkeletonProps) {
  return (
    <span
      role="presentation"
      aria-hidden
      className={cn('block bg-gray-200 animate-pulse rounded', className)}
      style={style}
    />
  );
}
